
import React, { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { mergeStyleSets } from 'office-ui-fabric-react/lib/Styling';

import ContainerWithToolbar from '../../common/client/components/toolbar/ContainerWithToolbar';
import MapBase from '../../common/client/components/map/MapBase';
import ButtonCommandZoomIn from '../../common/client/components/map/ButtonCommandZoomIn';
import ButtonCommandZoomOut from '../../common/client/components/map/ButtonCommandZoomOut';
import ButtonCommandZoomDefault from '../../common/client/components/map/ButtonCommandZoomDefault';
import LayerSwitcherButton from '../../common/client/components/map/LayerSwitcherButton';

import mapGetActions from '../../sagas/map';

import MapView  from './Map.view';
import MAP_PROJECT from './mapProjectDef';
import OlMapPlugin from './openlayers/OlMapPlugin';

const classNames = mergeStyleSets({
    layers: {
        position: 'absolute',
        zIndex: 100,
        right: 64,
        padding: 0
    }
});

const MapState = ({parItem}) => {

    const dispatch = useDispatch();
    const mapActions = mapGetActions(dispatch);

    const map = useSelector(state => state.map);

    const olMapPlugin = useRef();

    const mapRef = useRef();

    useEffect(() => {
        mapActions.initProject(MAP_PROJECT);
        mapActions.addCommand(
            'EXEC_CODE',
            {
                callback: initMap
            }
        );
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (parItem) {
            const x = parseInt(parItem.souradnice_y) * -1;
            const y = parseInt(parItem.souradnice_x) * -1;
            mapActions.addCommand(
                'HIGHLIGHT_FEATURE',
                {
                    geoJson: `{"type":"Feature","geometry":{"type":"Point","coordinates":[${x},${y}]}}`,
                    geoJsons: null,
                    zoomToFeature: true
                }
            );
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [parItem]);

    const handleChangeView = (center, zoom, rotation, resolution) => {
        mapActions.changeView(center, zoom, rotation, resolution);
    }

    const initMap = (map, params, olMap) => {
        olMapPlugin.current = new OlMapPlugin({
            olMap: olMap
        });
        olMapPlugin.current.init();
    }

    const mapButtons = [
        <ButtonCommandZoomIn />,
        <ButtonCommandZoomOut />,
        <ButtonCommandZoomDefault
            map={map}
            defaultExtent={MAP_PROJECT.extent}
        />,
    ];

    const componentMap = (
        <ContainerWithToolbar toolbarPosition="right" toolbarDirection="" buttons={mapButtons}>
            <div className={classNames.layers}>
                <LayerSwitcherButton
                    map={map}
                    layers={map.layers}
                    groups={map.groups}
                    moduleActions={mapActions}
                />
            </div>
            <MapBase
                ref={mapRef}
                map={map}
                layers={map.layers}
                groups={map.groups}
                onChangeView={handleChangeView}
                moduleActions={mapActions}
            />
        </ContainerWithToolbar>
    );

    return (
        <MapView
            componentMap={componentMap}
        />
    )
};

export default MapState;
